import { UnauthorizedError } from '@api/Errors'
import ErrorHandler from '@api/ErrorHandler'

export default class UnauthorizedErrorHandler extends ErrorHandler {
  constructor(response, options = {}) {
    if (options.autoRedirect === undefined) {
      options.autoRedirect = true
    }
    super(response, options.autoRedirect ? 'login' : '')
    throw new UnauthorizedError('401 Unauthorized', response)
  }
}
